export default "__VITE_ASSET__bcee23ba__"